import React, { AnchorHTMLAttributes } from 'react';

type Props = AnchorHTMLAttributes<HTMLAnchorElement>;

const StripeButton: React.FC<Props> = ({ children, className = 'btn', ...other }) => {
  return (
    <a className={`min-w-52 w-full ${className} cursor-pointer`} target='_blank' {...other}>
      {children}
    </a>
  );
};
export default StripeButton;
